import createRefdataApi from "../createRefdataApi";
import { ApolloClient } from "@apollo/client";
import {
  EogAfeTypeValuesQuery,
  EogAfeTypeValuesDocument,
} from "./query.hotchoc.generated";
import { hotChocolateClientContext } from "~/Apollo";
import { EogAfeType } from "~/gql/types";

async function eogAfeTypeFetcher(client: ApolloClient<any>) {
  const result = await client.query<EogAfeTypeValuesQuery>({
    query: EogAfeTypeValuesDocument,
    context: hotChocolateClientContext,
  });

  return result.data?.eogAfeTypeValues?.all as EogAfeType[];
}

const api = createRefdataApi(eogAfeTypeFetcher, "gen sub values");

export const EogAfeTypeValuesRefDataContext = api.Provider;
export const useEogAfeTypeValuesAsync = api.useDataAsync;
export const useEogAfeTypeValues = api.useData;
export const useInvalidateEogAfeTypeValues = api.useInvalidate;
